export const NEWSLETTER_MEDIUM = 'newsletter'

export const NEWSLETTER_QUALIFIED_PROPERTY = 'newsletterHumanQualified'
export const NEWSLETTER_QUALIFICATION_PROPERTY = 'newsletterQualification'

export type NewsletterQualificationReason = 'activity' | 'dwell'

export interface NewsletterBeaconContext {
  humanQualified: boolean
}

export const isNewsletterMedium = (value: string | null | undefined): boolean =>
  value?.trim().toLowerCase() === NEWSLETTER_MEDIUM

// Rollup counters (`analytics_event_daily`) so the two suppressed cohorts stay
// countable. Filtering that leaves no trace can't be audited: the follow-up
// review in docs/decisions/2026-08-18-newsletter-scanner-analytics-filtering.md
// has to be able to tell a shrinking scanner wave from a filter that quietly
// stopped matching, or a gate that started rejecting real readers. Both are one
// increment per suppressed session — no PostHog event, no site_events row.
export const NEWSLETTER_UNQUALIFIED_ROLLUP_KEY = 'newsletter-unqualified:drop'
export const NEWSLETTER_SCANNER_ROLLUP_KEY = 'newsletter-scanner:drop'
